import  React, {useCallback} from 'react';
import _ from 'underscore';
import Dropzone, {useDropzone} from 'react-dropzone'
import ellipseIcon from '../../assets/svgs/ellipse.svg';
import cameraIcon from '../../assets/pngs/camera-icon.png';

import { NoteBox } from './note_box.jsx';

export const ImageInput = (props) => {
  const {
    id,
    title,
    onDrop,
    onRemove,
    fieldName,
    mandatory,
    previews,
    label,
    helpText,
    uploadSuccessful,
    failText,
    instructionText,
    onImageClick,
    imgHelptext,
    addImageButtonText,
  } = props;
  var previewElements = null;
  var modal = null;
  let hasExistingImage = false;
  if (previews != null) {
    previewElements = previews.map((img) => {
      if (!img?.file) return null;
      hasExistingImage = hasExistingImage || img.file.isExistingImage;
      return (
        <div className="image-preview-wrapper" key={img.file.preview}>
          <img
            className={`image-preview ${img.file.isExistingImage ? "previous-survey-image" : ""}`}
            key={img.file.preview}
            src={img.file.preview}
            onClick={(e) => {
              onImageClick(img, id);
              e.stopPropagation();
            }}
          />
          {img.file.isExistingImage && (
            <img className="ellipse-icon" src={ellipseIcon} alt="ellipse-icon" />
          )}
        </div>
      );
    }).filter(Boolean);
  }

  return (
    <Dropzone className="dropzone" onDrop={onDrop} noClick noKeyboard>
      {({getRootProps, getInputProps, open}) => (
        <div id={id} className="dropzone" {...getRootProps()}>
          { helpText
            ? <NoteBox data={[ { text: helpText } ]} theme="help"/> : null
          }
          <div className="head">{title}{mandatory && <span className="mandatory-asterix"> *</span>}</div>
          <div className="input-dz">
            { (previewElements == null || previewElements.length == 0)
              ? <div className="label"> {label} </div>
              : null
            }

            <input {...getInputProps()} />
            { previewElements }
          </div>
          <div className="add-image-container">
            <button
              id="addImageBtn"
              disabled={previews && previews.length >= 5}
              className={`standard-btn add-image-btn ${previews && previews.length >= 5 ? "disabled" : ""}`}
              onClick={(e) => {
                e.preventDefault();
                open();
              }}
            >
              <img className="camera-icon" src={cameraIcon} alt="camera-icon" />
              <span className='button-text'>{ addImageButtonText || 'Add Image' }</span>
            </button>
            {hasExistingImage && (
              <div className="image-note">
                <img className="ellipse-icon-text" src={ ellipseIcon } alt="ellipse-icon" />
                <span className="bold-text">{ imgHelptext }</span>
              </div>
            )}
            <div className="instruction-text">{instructionText}</div>
          </div>
          { !uploadSuccessful
            ? <div className="fail-note">
                  <div className="icon error-icon"/>
                  <div className="fail-text">{failText}</div>
              </div>
            : null
          }
          { modal }
        </div>
      )}
    </Dropzone>
  );
};
